import { createServerFn } from "@tanstack/react-start";
import { isSystemAdmin } from "shared/User";
import { fetchAuthState } from "src/lib/ServerUtils";

/** Recheck the session before route loaders or preloads fetch any back-office code. */
export const getAdminAccess = createServerFn({ method: "GET" }).handler(async () =>
  isSystemAdmin((await fetchAuthState({ noCache: true }))?.user),
);
